import { ChatBubbleOvalLeftIcon } from "@heroicons/react/24/outline";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import Typography from "components/elements/Typography";

type IProps = {
	onClick: () => void;
};

export default function CommentReplyButton(props: IProps) {
	return (
		<div className={classes["root"]} onClick={props.onClick}>
			<ChatBubbleOvalLeftIcon className={classes["icon"]} />
			<Typography color="primary">{I18n.asset.pages.post.comment.reply.submit}</Typography>
		</div>
	);
}
